import router from '@/router'
import { upDataUserInfo } from '@/api/common'
import { getCookie, setCookie, removeCookie } from '@/utils/cookies'
import { callNativeApp } from '@/utils/OverallJsMobile'

export const upUserInfo = () => {
  $HMD$.GetLogin(function (data) {
    if (data && +data.AccountId) {
      setCookie('accountId', data.AccountId)
      const obj = {
        address: data.Address || '',
        email: data.Email || '',
        gender: data.Gender || '',
        idCardNumber: data.IdCardNumber || '',
        idCardPhoto: data.IdCardFileName || '',
        mobile: data.Mobile || '',
        nickName: data.Nickname || '',
        realName: data.AccountRealName || '',
        userAvatar: data.FullFileName || '',
        userId: data.AccountId,
        userName: data.AccountName,
        xiaonengSettingId: data.XiaoNengSettingId || ''
      }
      upDataUserInfo(obj)
    } else {
      $HMD$.Cookie({
        type: "del",
        name: "ticket"
      });
      $HMD$.Cookie({
        type: "del",
        name: "accountId"
      });
      $HMD$.Cookie({
        type: "del",
        name: "AccountId"
      });
      removeCookie('accountId')
      removeCookie('AccountId')
    }
  })

}

/* 判断是否移动端 */
export const isMobile = () => {
  let ua = navigator.userAgent
  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/)
  let isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/)
  let isAndroid = ua.match(/(Android)\s+([\d.]+)/)

  let userAgentInfo = navigator.userAgent.toLowerCase();
  let Agents = new Array('android', 'iphone', 'symbianOS', 'windows phone', 'ipad', 'ipod' , 'micromessenger', 'miniprogram');
  let isSJ = false;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          isSJ = true;
          break;
      }
  }

  let isMobile = isIphone || isAndroid || isSJ
  return isMobile
}

/**
 * 去登陆
 */
export const toLogin = () => {
// 判断环境 跳转不同登录页面
  if (process.env.ENV_CONFIG !== 'dev' && isMobile() && getCookie('homedo_port') === 'app') {
    callNativeApp('login', '', '')
  } else {
    if (router.history.current.fullPath.split('?')[1]) {
      window.location.href = `${process.env.CAS_URL}${window.location.origin}${router.history.current.fullPath.split('?')[0]}?${encodeURIComponent(router.history.current.fullPath.split('?')[1])}`
    } else {
      window.location.href = `${process.env.CAS_URL}${window.location.origin}${router.history.current.fullPath.split('?')[0]}`
    }
  }
}

export const isLogin = () => {
  if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
    return false
  }
  if ($HMD$.rNavigator === 'msite' && (!getCookie('AccountId') && !getCookie('accountId'))) {
    return false
  }
  return true
}

/**
 * 设置本地缓存
 * @param key
 * @param value
 */
export const settingCache = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

/**
 * 清除指定缓存
 * @param key
 */
export const clearCache = (key) => {
  if (!window.localStorage.getItem(key)) {
    return
  }
  window.localStorage.removeItem(key)
}

/**
 * 获取本地缓存
 * @param key
 * @returns {string}
 */
export const getterCache = (key) => {
  return window.localStorage.getItem(key)
}

export const verifyLoginStatus = () => {
  $HMD$.GetLogin(function (data) {
    if (data && +data.AccountId) {
      setCookie('accountId', data.AccountId)
    } else {
      console.log(12344)
      $HMD$.Cookie({
        type: "del",
        name: "ticket"
      });
      $HMD$.Cookie({
        type: "del",
        name: "accountId"
      });
      $HMD$.Cookie({
        type: "del",
        name: "AccountId"
      });
      removeCookie('accountId')
      removeCookie('AccountId')
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/common.js